export const RTL_LANGUAGES = ["ar", "he", "fa", "ur"]
